module.exports = __webpack_public_path__ + "img/produto-supercoffee.94e61909.png";